import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=d6ddb1b2&scoped=true&"
import script from "./WordCloud.vue?vue&type=script&lang=js&"
export * from "./WordCloud.vue?vue&type=script&lang=js&"
import style0 from "./WordCloud.vue?vue&type=style&index=0&id=d6ddb1b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ddb1b2",
  null
  
)

export default component.exports